var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBathroom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4583 5.08333H3.54167V2.95833C3.54167 2.17704 4.17704 1.54167 4.95833 1.54167C5.73963 1.54167 6.375 2.17704 6.375 2.95833H7.79167C7.79167 1.39575 6.52092 0.125 4.95833 0.125C3.39575 0.125 2.125 1.39575 2.125 2.95833V5.08333H0.708333C0.520472 5.08333 0.340304 5.15796 0.207466 5.2908C0.0746277 5.42364 0 5.6038 0 5.79167V7.20833C0 9.05425 1.18575 10.6246 2.83333 11.2104V13.5833H4.25V11.4583H9.91667V13.5833H11.3333V11.2104C12.9809 10.6246 14.1667 9.05425 14.1667 7.20833V5.79167C14.1667 5.6038 14.092 5.42364 13.9592 5.2908C13.8264 5.15796 13.6462 5.08333 13.4583 5.08333ZM12.75 7.20833C12.75 8.77092 11.4793 10.0417 9.91667 10.0417H4.25C2.68742 10.0417 1.41667 8.77092 1.41667 7.20833V6.5H12.75V7.20833Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBathroom);
export default __webpack_public_path__ + "static/media/bathroom.d1ababb52432c8f77c23f9112d0f79ff.svg";
export { ForwardRef as ReactComponent };